import { useParams } from "react-router-dom"
import { useGetDictamenesQuery } from "../../../services/docs"
import { Spinner } from "../../../components/Spinner"
import { ItemDato } from "../../../components/ItemDato"

export const DictamenesScreen = () => {
  let { siniestro = 0, tramite_id = 0 } = useParams()
  const { data, isLoading,isError } = useGetDictamenesQuery({ siniestro, tramite: tramite_id })
  if (isLoading) {
    return <div className='flex w-full justify-center'><Spinner /></div>
  }
  return (
    <div className="grid grid-cols-1 gap-4 place-items-stretch">
      {isError && <h1 className='mx-auto py-1 rounded w-2/3 text-center bg-warning'>El Dictamen aún no existe</h1>}
      {data && data.dictamenes && data.dictamenes.length > 0 && data.dictamenes.map((dic: any) => {
        return (
          <div className="card flex flex-col space-y-5" key={dic.id}>
            <div className='grid grid-cols-4 gap-4 place-items-stretch'>
              <ItemDato titulo={'Id de Dictamen'} subtitulo={dic.id} />
              <ItemDato titulo={'Respuesta Dictamen'} subtitulo={dic.fc_respuesta_aseguradora} />
              <ItemDato titulo={'Comentario Dictamen'} subtitulo={dic.fc_comentarios_dictamen} />
              <ItemDato titulo={'Siniestro Aseguradora'} subtitulo={dic.fc_siniestro_aseguradora} />
              <ItemDato titulo={'Fecha Dictamen'} subtitulo={dic.fd_fecha_dictamen} />
              <ItemDato titulo={'Resolución Auditoria'} subtitulo={dic.fc_resolucion_auditoria} />
              <ItemDato titulo={'Monto Pagado'} subtitulo={dic.fn_monto_pagado} />
              <ItemDato titulo={'Comentario Auditoria'} subtitulo={dic.fc_comentarios_auditoria} />
              <ItemDato titulo={'Fecha Auditoria'} subtitulo={dic.fd_fecha_auditoria} />
              <div className="">
                <p className="block text-base ">
                  <a className='text-primary bg-primary text-white focus-visible:ring-primary-ultra-light px-4 py-2 text-sm' href={dic.fc_url_carta} target='_blank'>Ver carta dictamen</a>
                </p>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
